import PageTitle from "../components/PageTitle";
import { GoListUnordered } from "react-icons/go";
import threeDot from "../assets/img/dashboard/threeDot.svg";
import { TfiAngleDown } from "react-icons/tfi";
import { BsThreeDots } from "react-icons/bs";
import { useEffect, useState, useMemo, useCallback } from "react";
import Select from "react-select";
import { LiaAngleLeftSolid } from "react-icons/lia";
import StrategiesDC from "../components/StrategiesDC";
import Api from "../api/api.js";
import FormBox from "../components/FormBox.jsx";
import brokerjson from "../services/Helpers/BrokerFields.json";
import metrics from "../helpersjson/Metrics.json";
import { Col, Container, Row, Dropdown } from "react-bootstrap";
import Spinner from "../components/common/Spinner";
import icon1 from "../assets/img/marketplace/1.png";
import icon2 from "../assets/img/marketplace/2.png";
import icon3 from "../assets/img/marketplace/3.png";
import icon4 from "../assets/img/marketplace/4.png";
import icon5 from "../assets/img/marketplace/5.png";
import icon6 from "../assets/img/marketplace/5.png";
import { Link, useNavigate } from "react-router-dom";
import TagColors from "../Colors.json";
import Aesfile from '../services/Utils/aes.js';
import LineChart from "../components/dashbaord/Linechart";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { FaSync } from "react-icons/fa";

import AboutStrategies from "./AboutStrategies.js";
const options = Object.keys(brokerjson).map((key) => ({
  value: key,
  label: key,
}));

const iconMap = {
  icon1: icon1,
  icon2: icon2,
  icon3: icon3,
  icon4: icon4,
  icon5: icon5,
  icon6: icon6,
};
export default function Strategies() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  let [strategiesMe, setStrategiesMe] = useState([]);
  let [strategiesSub, setStrategiesSub] = useState([]);
  const [strategies, setstrategies] = useState([]);
  const [modal, setmodal] = useState(false);
  const [loading, setLoading] = useState(true);
  
  // Filter and Sort states
  const [filters, setFilters] = useState({
    minWinPct: "",
    maxWinPct: "",
    minOverallPnl: "",
    maxOverallPnl: "",
    minAvgPnl: "",
    maxAvgPnl: "",
    minLossPct: "",
    maxLossPct: "",
    minDays: "",
    maxDays: "",
    selectedTags: [],
    publishedUser: ""
  });
  const [sortBy, setSortBy] = useState("active");
  const [sortOrder, setSortOrder] = useState("desc");
  const [showFilters, setShowFilters] = useState(false);
  const [viewMode, setViewMode] = useState("grid"); // "grid" or "list"
  
  // Modal action states
  // Removed modalTab - using drawer panel with inline actions instead
  const [selectedAction, setSelectedAction] = useState("Results");
  const [actionModal, setActionModal] = useState(false);
  const [editDescription, setEditDescription] = useState(false);
  const [editTags, setEditTags] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [resultsData, setResultsData] = useState([]);
  const [selectedResult, setSelectedResult] = useState(null);
  const [resultChartData, setResultChartData] = useState([]);
  const [resultsActiveTab, setResultsActiveTab] = useState("backTesting"); // "backTesting" or "liveRuns"
  const [dayRunDetails, setDayRunDetails] = useState({});
  const [openSections, setOpenSections] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [actionValues, setActionValues] = useState({
    broker_id: null,
    start_date: "",
    end_date: "",
    strategy_id: "",
    interval: "",
    user_id: JSON.parse(localStorage.getItem("user_details"))?.user_id,
    run_type: "paper"
  });
  
  const intervalOptions = [
    { value: "1_min", label: "1 min" },
    { value: "5_mins", label: "5 mins" },
    { value: "15_mins", label: "15 mins" },
    { value: "1_hr", label: "1 hr" },
  ];
  
  const tagOptions = [
    { value: "Nifty", label: "Nifty" },
    { value: "Bse", label: "Bse" },
    { value: "Money Bager", label: "Money Bager" },
    { value: "Cobra", label: "Cobra" },
  ];

  // Helper functions to determine metric source
  const getMetricSourceLabel = (strategy) => {
    if (!strategy?.run_type) return null;
    
    // If cycling and both metrics available, use current cycling state
    if (strategy.has_both_metrics && cyclingMetrics[strategy.strategy_id]) {
      return cyclingMetrics[strategy.strategy_id] === 'L' ? 'Live' : 'Backtest';
    }
    
    return strategy.run_type === 'L' ? 'Live' : 'Backtest';
  };

  const getMetricSourceColor = (strategy) => {
    if (!strategy?.run_type) return '#6c757d';
    
    // If cycling and both metrics available, use current cycling state
    if (strategy.has_both_metrics && cyclingMetrics[strategy.strategy_id]) {
      return cyclingMetrics[strategy.strategy_id] === 'L' ? '#28a745' : '#007bff';
    }
    
    return strategy.run_type === 'L' ? '#28a745' : '#007bff'; // Green for Live, Blue for Backtest
  };

  const getMetricSourceIcon = (strategy) => {
    if (!strategy?.run_type) return null;
    
    // If cycling and both metrics available, use current cycling state
    if (strategy.has_both_metrics && cyclingMetrics[strategy.strategy_id]) {
      return cyclingMetrics[strategy.strategy_id] === 'L' ? '⚡' : '📊';
    }
    
    return strategy.run_type === 'L' ? '⚡' : '📊'; // Lightning for Live, Chart for Backtest
  };

  // Get current metrics based on cycling state
  const getCurrentMetrics = (strategy) => {
    if (strategy.has_both_metrics && cyclingMetrics[strategy.strategy_id]) {
      const currentType = cyclingMetrics[strategy.strategy_id];
      if (currentType === 'L' && strategy.live_metrics) {
        return strategy.live_metrics.metrics;
      } else if (currentType === 'B' && strategy.backtest_metrics) {
        return strategy.backtest_metrics.metrics;
      }
    }
    return strategy.metrics || {};
  };

  const [values, setValues] = useState({
    broker_name: "",
    start_date: "",
    end_date: "",
    strategy_id: "",
    user_id: JSON.parse(localStorage.getItem("user_details")).user_id,
  });
  const [activeTab, setActiveTab] = useState("createdByMe");
  const [showAbtSt, setShowAbtStr] = useState(false);
  const [selectedStrategy, setselectedStrategy] = useState({});

  const MenuItems = [{ link: "Back Testing" }, { link: "Publish Strategy" }];

  const [isList, setIsList] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [showActionsDropdown, setShowActionsDropdown] = useState({});
  const [cyclingMetrics, setCyclingMetrics] = useState({}); // Track which metric type is showing for each strategy
  const [metricTransition, setMetricTransition] = useState({}); // Track transition state

  useEffect(() => {
    // Run API calls in parallel for faster loading
    Promise.all([
      getStrategies(),
      getBrokers()
    ]).catch(error => {
      console.error("Error loading initial data:", error);
    });
  }, []);

  // Memoize cycling strategies to prevent unnecessary recalculations
  const cyclingStrategiesList = useMemo(() => {
    const cyclingStrategies = {};
    
    // Find strategies with both metrics
    if (strategies?.my_strategies) {
      strategies.my_strategies.forEach(strategy => {
        if (strategy.has_both_metrics) {
          cyclingStrategies[strategy.strategy_id] = true;
        }
      });
    }
    if (strategies?.sub_strategies) {
      strategies.sub_strategies.forEach(strategy => {
        if (strategy.has_both_metrics) {
          cyclingStrategies[strategy.strategy_id] = true;
        }
      });
    }
    
    return cyclingStrategies;
  }, [strategies?.my_strategies, strategies?.sub_strategies]);

  // Initialize cycling state - default to Backtest (B)
  useEffect(() => {
    const cyclingStrategies = cyclingStrategiesList;
    
    if (Object.keys(cyclingStrategies).length === 0) return;

    // Initialize cycling state - start with Backtest (default)
    const initialCycling = {};
    Object.keys(cyclingStrategies).forEach(strategyId => {
      if (!cyclingMetrics[strategyId]) {
        initialCycling[strategyId] = 'B'; // Start with Backtest
      }
    });
    if (Object.keys(initialCycling).length > 0) {
      setCyclingMetrics(prev => ({ ...prev, ...initialCycling }));
    }
  }, [cyclingStrategiesList]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside any dropdown
      const isDropdownToggle = event.target.closest('.dropdown-toggle');
      const isDropdownMenu = event.target.closest('.dropdown-menu');
      
      if (!isDropdownToggle && !isDropdownMenu) {
        // Close all dropdowns
        setShowActionsDropdown({});
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle toggle switch for Live/Backtest
  const handleMetricToggle = (strategyId, strategy) => {
    // Only allow toggle if live data is available
    if (!strategy.has_both_metrics && !strategy.live_metrics) {
      return; // Don't toggle if no live data
    }
    
    setCyclingMetrics(prev => {
      const current = prev[strategyId] || 'B';
      const newValue = current === 'B' ? 'L' : 'B';
      return { ...prev, [strategyId]: newValue };
    });
  };

  async function getBrokers() {
    try {
      let res = await Api.brokers();
      // Decrypt in background to avoid blocking
      const res1 = await Aesfile.decryptPayload(res.data);
      setBrokers(
        res1.map((broker) => ({
          broker_id: broker.broker_id,
          value: broker.broker_name + "-" + broker.username,
          label: broker.broker_name + "-" + broker.username,
        }))
      );
    } catch (error) {
      console.error("Error fetching brokers:", error);
    }
  }

  async function getChartData(strategy) {
    if (!strategy?.run_id || !strategy?.run_type) return;
    try {
      const payload = {
        run_id: strategy.run_id,
        run_type: strategy.run_type
      };
      let res = await Api.runresults(payload);
      setChartData(res.data?.chart_data || []);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  }

  async function getResults() {
    if (!selectedStrategy?.strategy_id) return;
    try {
      const payload = {
        strategy_id: selectedStrategy.strategy_id,
        run_type: resultsActiveTab === "backTesting" ? "B" : "L",
      };
      let res = await Api.results(payload);
      setResultsData(res.data || []);
      if (res.data && res.data.length > 0) {
        setSelectedResult(res.data[0]);
        getResultChart(res.data[0]);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
      toast.error("Error while fetching results");
    }
  }

  async function getResultChart(result) {
    if (!result?.run_id) return;
    try {
      const payload = {
        run_id: result.run_id,
        run_type: resultsActiveTab === "backTesting" ? "B" : "L",
      };
      let res = await Api.runresults(payload);
      setResultChartData(res.data || {});
    } catch (error) {
      console.error("Error fetching result chart:", error);
    }
  }

  async function getRunDetailsByDate(runDay, index) {
    if (!selectedResult?.run_id) return;
    setIsLoadingDetails(true);
    try {
      const payload = {
        run_id: selectedResult.run_id,
        run_type: resultsActiveTab === "backTesting" ? "B" : "L",
        run_date: runDay?.run_date,
      };
      let res = await Api.getdayrunDetaisl(payload);
      if (res.data && res.data[0]?.position) {
        const position = JSON.parse(res.data[0].position);
        setDayRunDetails(position);
      }
      setOpenSections(index);
    } catch (error) {
      console.error("Error fetching run details:", error);
      toast.error("Error while fetching run details");
    } finally {
      setIsLoadingDetails(false);
    }
  }

  const toggleAccordion = (item, index) => {
    if (openSections === index) {
      setOpenSections(null);
    } else {
      getRunDetailsByDate(item, index);
    }
  };

  const calculateDate = (offsetDays) => {
    const today = new Date();
    today.setDate(today.getDate() + offsetDays);
    return today.toISOString().split("T")[0];
  };

  const handleActionSelectChange = (fieldName, fieldValue) => {
    setActionValues((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue,
    }));
  };

  async function executeAction() {
    try {
      const requiredFields = [];
      if (!actionValues.strategy_id) requiredFields.push("Strategy ID");
      if (!actionValues.start_date) requiredFields.push("Start Date");
      if (!actionValues.end_date) requiredFields.push("End Date");
      
      if (selectedAction !== "Publish Strategy") {
        if (!actionValues.broker_id) requiredFields.push("Broker");
        if (!actionValues.interval) requiredFields.push("Interval");
      }
      
      if (selectedAction === "Live Runs" && !actionValues.run_type) {
        requiredFields.push("Run Type");
      }
      
      if (requiredFields.length > 0) {
        toast.error(`Please fill in: ${requiredFields.join(", ")}`);
        return;
      }
      
      if (actionValues.start_date && actionValues.end_date) {
        const startDate = new Date(actionValues.start_date);
        const endDate = new Date(actionValues.end_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (startDate >= endDate) {
          toast.error("End date must be after start date");
          return;
        }
        
        if (selectedAction === "Back Testing") {
          if (startDate > today || endDate > today) {
            toast.error("Dates cannot be in the future for Back Testing");
            return;
          }
        }
      }
      
      let res;
      if (selectedAction === "Publish Strategy") {
        res = await Api.publishStrategy({
          strategy_id: actionValues.strategy_id,
          start_date: actionValues.start_date,
          end_date: actionValues.end_date,
        });
      } else if (selectedAction === "Back Testing") {
        res = await Api.backtestStrategy(actionValues);
      } else if (selectedAction === "Live Runs") {
        res = await Api.liveRunStrategy(actionValues);
      }
      
      setActionModal(false);
      setActionValues({
        broker_id: null,
        start_date: "",
        end_date: "",
        strategy_id: "",
        interval: "",
        user_id: JSON.parse(localStorage.getItem("user_details"))?.user_id,
        run_type: "paper"
      });
      toast.success(res?.message || "Action completed successfully");
      getStrategies(); // Refresh strategies list
      
      // Refresh results if Results tab is currently open
      // Retry multiple times with increasing delays since backtesting may take time to complete
      if (detailsModal && selectedAction === "Results" && selectedStrategy?.strategy_id) {
        const refreshResults = async (attempt = 1, maxAttempts = 5) => {
          const delays = [2000, 5000, 10000, 15000, 20000]; // Increasing delays: 2s, 5s, 10s, 15s, 20s
          const delay = delays[Math.min(attempt - 1, delays.length - 1)];
          
          setTimeout(async () => {
            if (detailsModal && selectedAction === "Results" && selectedStrategy?.strategy_id) {
              await getResults();
              // Retry if not the last attempt
              if (attempt < maxAttempts) {
                refreshResults(attempt + 1, maxAttempts);
              }
            }
          }, delay);
        };
        refreshResults();
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while processing the request");
    }
  }

  async function deleteStrategy() {
    if (!window.confirm("Are you sure you want to delete this strategy? This action cannot be undone.")) {
      return;
    }
    try {
      const payload = {
        strategy_id: selectedStrategy?.strategy_id
      };
      let res = await Api.deleteStrategy(payload);
      toast.success(res?.message || "Strategy deleted successfully");
      setDetailsModal(false);
      getStrategies(); // Refresh strategies list
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete strategy");
    }
  }

  async function updateStrategy(data) {
    try {
      let res = await Api.strategyUpdate(data);
      toast.success("Strategy updated successfully");
      getStrategies(); // Refresh strategies list
    } catch (error) {
      console.error(error);
      toast.error("Failed to update strategy");
    }
  }

  const handleTagSelectChange = (selected) => {
    const selectedValues = selected?.map((item) => item.value) || [];
    setSelectedTags(selected);
    if (selectedStrategy?.strategy_id) {
      updateStrategy({
        strategy_id: selectedStrategy.strategy_id,
        tags: selectedValues,
      });
    }
  };

  // Load chart data and set initial values when modal opens
  useEffect(() => {
    if (detailsModal && selectedStrategy?.strategy_id) {
      setDescriptionValue(selectedStrategy.strategy_desc || "");
      setSelectedTags((selectedStrategy.tags || []).map(tag => ({ value: tag, label: tag })));
      getChartData(selectedStrategy);
      setActionValues(prev => ({
        ...prev,
        strategy_id: selectedStrategy.strategy_id
      }));
      // Reset results when modal opens
      setResultsData([]);
      setSelectedResult(null);
      setResultChartData([]);
    }
  }, [detailsModal, selectedStrategy]);

  // Fetch results when Results action is selected
  useEffect(() => {
    if (selectedAction === "Results" && selectedStrategy?.strategy_id && detailsModal) {
      getResults();
    }
  }, [selectedAction, resultsActiveTab, selectedStrategy?.strategy_id, detailsModal]);

  // Show action form when an action is selected (not Results or Delete)
  useEffect(() => {
    if (selectedAction && selectedAction !== "Results" && selectedAction !== "Delete" && detailsModal) {
      setActionModal(true);
      // Initialize action values with strategy_id
      if (selectedStrategy?.strategy_id) {
        setActionValues(prev => ({
          ...prev,
          strategy_id: selectedStrategy.strategy_id
        }));
      }
    } else if (!selectedAction || selectedAction === "Results" || selectedAction === "Delete") {
      setActionModal(false);
    }
  }, [selectedAction, selectedStrategy?.strategy_id, detailsModal]);

  async function getStrategies() {
    try {
      setLoading(true);
      let res = await Api.strategiesMe();
      const data = res?.data || {};
      setstrategies(data);
      // Filtered/sorted strategies will be set by useMemo and useEffect
      // This prevents double processing and improves performance
    } catch (error) {
      console.error("Error while fetching Strategies:", error);
      alert("Error while fetching Strategies");
    } finally {
      setLoading(false);
    }
  }

  // Get all unique tags from strategies
  const getAllTags = () => {
    const allTags = new Set();
    if (strategies.my_strategies) {
      strategies.my_strategies.forEach(item => {
        if (item.tags && Array.isArray(item.tags)) {
          item.tags.forEach(tag => allTags.add(tag));
        }
      });
    }
    if (strategies.sub_strategies) {
      strategies.sub_strategies.forEach(item => {
        if (item.tags && Array.isArray(item.tags)) {
          item.tags.forEach(tag => allTags.add(tag));
        }
      });
    }
    return Array.from(allTags).sort();
  };

  // Apply filters to strategies - memoized to prevent unnecessary recalculations
  const applyFilters = useCallback((strategyList) => {
    if (!strategyList) return [];
    
    return strategyList.filter(item => {
      const metrics = item.metrics || {};

      // Win Percentage filter
      if (filters.minWinPct && metrics.win_pct !== undefined) {
        if (parseFloat(metrics.win_pct) < parseFloat(filters.minWinPct)) {
          return false;
        }
      }
      if (filters.maxWinPct && metrics.win_pct !== undefined) {
        if (parseFloat(metrics.win_pct) > parseFloat(filters.maxWinPct)) {
          return false;
        }
      }

      // Overall P&L filter
      if (filters.minOverallPnl && metrics.overall_pnl !== undefined) {
        if (parseFloat(metrics.overall_pnl) < parseFloat(filters.minOverallPnl)) {
          return false;
        }
      }
      if (filters.maxOverallPnl && metrics.overall_pnl !== undefined) {
        if (parseFloat(metrics.overall_pnl) > parseFloat(filters.maxOverallPnl)) {
          return false;
        }
      }

      // Average P&L filter
      if (filters.minAvgPnl && metrics.avg_pnl !== undefined) {
        if (parseFloat(metrics.avg_pnl) < parseFloat(filters.minAvgPnl)) {
          return false;
        }
      }
      if (filters.maxAvgPnl && metrics.avg_pnl !== undefined) {
        if (parseFloat(metrics.avg_pnl) > parseFloat(filters.maxAvgPnl)) {
          return false;
        }
      }

      // Loss Percentage filter
      if (filters.minLossPct && metrics.loss_pct !== undefined) {
        if (parseFloat(metrics.loss_pct) < parseFloat(filters.minLossPct)) {
          return false;
        }
      }
      if (filters.maxLossPct && metrics.loss_pct !== undefined) {
        if (parseFloat(metrics.loss_pct) > parseFloat(filters.maxLossPct)) {
          return false;
        }
      }

      // Number of Days filter
      if (filters.minDays && metrics.no_of_days !== undefined) {
        if (parseFloat(metrics.no_of_days) < parseFloat(filters.minDays)) {
          return false;
        }
      }
      if (filters.maxDays && metrics.no_of_days !== undefined) {
        if (parseFloat(metrics.no_of_days) > parseFloat(filters.maxDays)) {
          return false;
        }
      }

      // Tags filter
      if (filters.selectedTags.length > 0 && item.tags) {
        const hasMatchingTag = filters.selectedTags.some(tag => 
          item.tags.includes(tag)
        );
        if (!hasMatchingTag) {
          return false;
        }
      }

      // Published User filter (for subscribed strategies)
      if (filters.publishedUser && item.published_user) {
        if (!item.published_user.toLowerCase().includes(filters.publishedUser.toLowerCase())) {
          return false;
        }
      }

      return true;
    });
  }, [filters]);

  // Sort strategies - apply selected sort - memoized
  const sortStrategies = useCallback((strategyList) => {
    if (!strategyList) return [];
    
    const sorted = [...strategyList].sort((a, b) => {
      // Apply the selected sort
      let aValue, bValue;

      switch (sortBy) {
        case "active":
          // Sort by active status (true = 1, false = 0)
          aValue = a.is_active === true ? 1 : 0;
          bValue = b.is_active === true ? 1 : 0;
          // If both have same active status, sort by latest run date for active ones
          if (aValue === bValue && aValue === 1) {
            const aLatestRun = a.latest_run_date ? new Date(a.latest_run_date).getTime() : 0;
            const bLatestRun = b.latest_run_date ? new Date(b.latest_run_date).getTime() : 0;
            if (aLatestRun !== bLatestRun) {
              return bLatestRun - aLatestRun; // Most recent first
            }
          }
          break;
        case "name":
          aValue = (a.strategy_name || "").toLowerCase().trim();
          bValue = (b.strategy_name || "").toLowerCase().trim();
          break;
        case "win_pct":
          aValue = parseFloat(a.metrics?.win_pct || 0);
          bValue = parseFloat(b.metrics?.win_pct || 0);
          break;
        case "overall_pnl":
          aValue = parseFloat(a.metrics?.overall_pnl || 0);
          bValue = parseFloat(b.metrics?.overall_pnl || 0);
          break;
        case "avg_pnl":
          aValue = parseFloat(a.metrics?.avg_pnl || 0);
          bValue = parseFloat(b.metrics?.avg_pnl || 0);
          break;
        case "no_of_days":
          aValue = parseFloat(a.metrics?.no_of_days || 0);
          bValue = parseFloat(b.metrics?.no_of_days || 0);
          break;
        default:
          return 0;
      }

      // Handle null/undefined values
      if (aValue === null || aValue === undefined) aValue = sortBy === "name" ? "" : 0;
      if (bValue === null || bValue === undefined) bValue = sortBy === "name" ? "" : 0;

      // Apply sort order
      if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
      
      // If values are equal, use name as secondary sort for consistency
      if (sortBy !== "name") {
        const aName = (a.strategy_name || "").toLowerCase().trim();
        const bName = (b.strategy_name || "").toLowerCase().trim();
        if (aName < bName) return -1;
        if (aName > bName) return 1;
      }
      
      return 0;
    });

    return sorted;
  }, [sortBy, sortOrder]);

  // Apply search, filters, and sort - memoized for performance
  const getFilteredAndSortedStrategies = useCallback((originalList) => {
    if (!originalList || !strategies) return [];
    
    // First apply search
    let filtered = originalList;
    if (search) {
      const lowerCaseQuery = search.toLowerCase();
      filtered = originalList.filter((item) =>
      Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(lowerCaseQuery)
        )
      );
    }

    // Then apply filters
    filtered = applyFilters(filtered);

    // Finally apply sort
    filtered = sortStrategies(filtered);

    return filtered;
  }, [search, applyFilters, sortStrategies, strategies]);

  function searchArray(query) {
    setSearch(query.target.value);
  }

  // Memoize filtered strategies to prevent unnecessary recalculations
  const filteredStrategiesMe = useMemo(() => {
    if (!strategies?.my_strategies) return [];
    return getFilteredAndSortedStrategies(strategies.my_strategies);
  }, [strategies?.my_strategies, getFilteredAndSortedStrategies]);

  const filteredStrategiesSub = useMemo(() => {
    if (!strategies?.sub_strategies) return [];
    return getFilteredAndSortedStrategies(strategies.sub_strategies);
  }, [strategies?.sub_strategies, getFilteredAndSortedStrategies]);

  // Update displayed strategies when filtered results change
  useEffect(() => {
    setStrategiesMe(filteredStrategiesMe);
  }, [filteredStrategiesMe]);

  useEffect(() => {
    setStrategiesSub(filteredStrategiesSub);
  }, [filteredStrategiesSub]);

  // Reset filters when tab changes
  useEffect(() => {
    setFilters({
      minWinPct: "",
      maxWinPct: "",
      minOverallPnl: "",
      maxOverallPnl: "",
      minAvgPnl: "",
      maxAvgPnl: "",
      minLossPct: "",
      maxLossPct: "",
      minDays: "",
      maxDays: "",
      selectedTags: [],
      publishedUser: ""
    });
    setSearch("");
  }, [activeTab]);

  const handleSelectChange = (fieldName, fieldValue) => {
    setValues((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue,
    }));
  };

  const toggleShowAbtStr = () => {
    setShowAbtStr(!showAbtSt);
    getStrategies();
  };
  const hasContent = (htmlString) => {
    const div = document.createElement("div");
    div.innerHTML = htmlString || "";
    return div.textContent.trim().length > 0;
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
        .metric-cycling {
          animation: fadeInOut 0.5s ease-in-out;
        }
        @keyframes fadeInOut {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 22px;
        }
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .switch .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 22px;
        }
        .switch .slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        .switch input:checked + .slider {
          background-color: #4dd5b8;
        }
        .switch input:checked + .slider:before {
          transform: translateX(18px);
        }
        .switch input:disabled + .slider {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .switch input:focus + .slider {
          box-shadow: 0 0 1px #4dd5b8;
        }
        .marketplace-items-cards-card {
          position: relative;
        }
        .marketplace-items-cards-card .dropdown-menu {
          max-width: calc(100% - 24px);
          min-width: 150px;
          visibility: visible !important;
          opacity: 1 !important;
          pointer-events: auto !important;
          display: block !important;
        }
        .marketplace-items-cards-card .dropdown.show .dropdown-menu {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        .marketplace-items-cards {
          overflow: visible !important;
        }
        .marketplace-items-row {
          overflow: visible !important;
        }
        .marketplace-items {
          overflow: visible !important;
        }
        .marketplace-items-cards-card .dropdown {
          position: relative !important;
        }
        .marketplace-items-cards-card .dropdown-toggle {
          position: relative !important;
        }
        .marketplace-items-cards-card .dropdown-menu {
          position: absolute !important;
          margin: 0 !important;
        }
      `}</style>
      {showAbtSt ? (
        <AboutStrategies
          setShowAbtStr={toggleShowAbtStr}
          data={selectedStrategy}
        />
      ) : (
        <>
          <PageTitle title="Home" />
          <div className="dashboard-wrap profile">
            <div className="profile-profit strategies bg-white">
              <div className="strategies-header d-flex mb-2 justify-content-between align-items-center flex-wrap gap-3">
                <div className="dashboard-topBar-search rounded-3 position-relative z-1" style={{ flex: "1", minWidth: "200px" }}>
                  <div className="icon d-flex align-items-center justify-content-center position-absolute top-50 translate-middle-y ms-3">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.75 15.7502L12.4928 12.4929M12.4928 12.4929C13.0499 11.9357 13.4919 11.2743 13.7934 10.5463C14.095 9.81834 14.2502 9.03811 14.2502 8.25015C14.2502 7.4622 14.095 6.68197 13.7934 5.95399C13.4919 5.22602 13.0499 4.56457 12.4928 4.0074C11.9356 3.45024 11.2741 3.00827 10.5462 2.70673C9.81819 2.4052 9.03795 2.25 8.25 2.25C7.46205 2.25 6.68181 2.4052 5.95384 2.70673C5.22587 3.00827 4.56442 3.45024 4.00725 4.0074C2.882 5.13265 2.24985 6.65881 2.24985 8.25015C2.24985 9.84149 2.882 11.3677 4.00725 12.4929C5.1325 13.6182 6.65866 14.2503 8.25 14.2503C9.84134 14.2503 11.3675 13.6182 12.4928 12.4929Z"
                        stroke="#8E8F95"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.75 15.7502L12.4928 12.4929M12.4928 12.4929C13.0499 11.9357 13.4919 11.2743 13.7934 10.5463C14.095 9.81834 14.2502 9.03811 14.2502 8.25015C14.2502 7.4622 14.095 6.68197 13.7934 5.95399C13.4919 5.22602 13.0499 4.56457 12.4928 4.0074C11.9356 3.45024 11.2741 3.00827 10.5462 2.70673C9.81819 2.4052 9.03795 2.25 8.25 2.25C7.46205 2.25 6.68181 2.4052 5.95384 2.70673C5.22587 3.00827 4.56442 3.45024 4.00725 4.0074C2.882 5.13265 2.24985 6.65881 2.24985 8.25015C2.24985 9.84149 2.882 11.3677 4.00725 12.4929C5.1325 13.6182 6.65866 14.2503 8.25 14.2503C9.84134 14.2503 11.3675 13.6182 12.4928 12.4929Z"
                        stroke="black"
                        strokeOpacity="0.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <input
                    type="search"
                    className="form-control border-0"
                    name=""
                    id=""
                    placeholder="Search"
                    value={search}
                    onChange={(e) => searchArray(e)}
                  />
                </div>
                <div className="strategies-btn d-flex align-items-center gap-2">
                  <button
                    className="btn d-flex align-items-center gap-2"
                    onClick={() => setShowFilters(!showFilters)}
                    style={{ 
                      whiteSpace: "nowrap",
                      background: showFilters ? "#4dd5b8" : "#f8f9fa",
                      color: showFilters ? "white" : "#495057",
                      border: showFilters ? "1px solid #4dd5b8" : "1px solid #dee2e6",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.66667 12C9.244 12 11.3333 9.91067 11.3333 7.33333C11.3333 4.756 9.244 2.66667 6.66667 2.66667C4.08933 2.66667 2 4.756 2 7.33333C2 9.91067 4.08933 12 6.66667 12Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M14 14L10.3333 10.3333" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                    Filters
                    {(() => {
                      const activeFilterCount = [
                        filters.minWinPct || filters.maxWinPct,
                        filters.minOverallPnl || filters.maxOverallPnl,
                        filters.minAvgPnl || filters.maxAvgPnl,
                        filters.minLossPct || filters.maxLossPct,
                        filters.minDays || filters.maxDays,
                        filters.selectedTags.length > 0,
                        filters.publishedUser
                      ].filter(Boolean).length;
                      return activeFilterCount > 0 ? (
                        <span 
                          className="badge rounded-pill"
                          style={{ 
                            background: showFilters ? "rgba(255,255,255,0.3)" : "#4dd5b8",
                            color: showFilters ? "white" : "white",
                            fontSize: "13px",
                            padding: "2px 6px"
                          }}
                        >
                          {activeFilterCount}
                        </span>
                      ) : null;
                    })()}
                    <TfiAngleDown style={{ 
                      transform: showFilters ? "rotate(180deg)" : "rotate(0deg)", 
                      transition: "transform 0.3s ease",
                      fontSize: "14px"
                    }} />
                  </button>
                  <div className="d-flex align-items-center gap-1 border rounded" style={{ borderColor: "#dee2e6" }}>
                    <button
                      className="btn btn-sm"
                      onClick={() => setViewMode("grid")}
                      style={{
                        background: viewMode === "grid" ? "#4dd5b8" : "transparent",
                        color: viewMode === "grid" ? "white" : "#495057",
                        border: "none",
                        borderRadius: "0.375rem 0 0 0.375rem",
                        padding: "6px 12px"
                      }}
                      title="Grid View"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
                        <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
                        <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
                        <rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2"/>
                      </svg>
                    </button>
                    <button
                      className="btn btn-sm"
                      onClick={() => setViewMode("list")}
                      style={{
                        background: viewMode === "list" ? "#4dd5b8" : "transparent",
                        color: viewMode === "list" ? "white" : "#495057",
                        border: "none",
                        borderRadius: "0 0.375rem 0.375rem 0",
                        padding: "6px 12px"
                      }}
                      title="List View"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="3" width="12" height="1.5" rx="0.5" fill="currentColor"/>
                        <rect x="2" y="7.25" width="12" height="1.5" rx="0.5" fill="currentColor"/>
                        <rect x="2" y="11.5" width="12" height="1.5" rx="0.5" fill="currentColor"/>
                  </svg>
                    </button>
                </div>
                  <Select
                    value={{ value: `${sortBy}_${sortOrder}`, label: `Sort: ${sortBy === "active" ? "Active" : sortBy === "name" ? "Name" : sortBy === "win_pct" ? "Win %" : sortBy === "overall_pnl" ? "Overall P&L" : sortBy === "avg_pnl" ? "Avg P&L" : "Days"} (${sortOrder === "asc" ? sortBy === "name" ? "A-Z" : sortBy === "active" ? "Inactive First" : "Low-High" : sortBy === "name" ? "Z-A" : sortBy === "active" ? "Active First" : "High-Low"})` }}
                    onChange={(selected) => {
                      if (selected) {
                        const [field, order] = selected.value.split("_");
                        setSortBy(field);
                        setSortOrder(order);
                      }
                    }}
                    options={[
                      { value: "active_desc", label: "Active (Active First)" },
                      { value: "active_asc", label: "Active (Inactive First)" },
                      { value: "name_asc", label: "Name (A-Z)" },
                      { value: "name_desc", label: "Name (Z-A)" },
                      { value: "win_pct_desc", label: "Win % (High to Low)" },
                      { value: "win_pct_asc", label: "Win % (Low to High)" },
                      { value: "overall_pnl_desc", label: "Overall P&L (High to Low)" },
                      { value: "overall_pnl_asc", label: "Overall P&L (Low to High)" },
                      { value: "avg_pnl_desc", label: "Avg P&L (High to Low)" },
                      { value: "avg_pnl_asc", label: "Avg P&L (Low to High)" },
                      { value: "no_of_days_desc", label: "Days (High to Low)" },
                      { value: "no_of_days_asc", label: "Days (Low to High)" }
                    ]}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minWidth: "200px",
                        fontSize: "14px"
                      })
                    }}
                  />
              </div>
              </div>
              
              {/* Filters Panel - Compact Horizontal Layout */}
              {showFilters && (
                <div 
                  className="filters-panel mb-3 rounded-3" 
                  style={{ 
                    background: "#ffffff",
                    border: "1px solid #e9ecef",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease"
                  }}
                >
                  <div 
                    className="px-3 py-2 d-flex justify-content-between align-items-center"
                    style={{ 
                      background: "#4dd5b8",
                      borderRadius: "0.5rem 0.5rem 0 0"
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.66667 12C9.244 12 11.3333 9.91067 11.3333 7.33333C11.3333 4.756 9.244 2.66667 6.66667 2.66667C4.08933 2.66667 2 4.756 2 7.33333C2 9.91067 4.08933 12 6.66667 12Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M14 14L10.3333 10.3333" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span className="text-white fw-semibold" style={{ fontSize: "14px" }}>Filters</span>
                    </div>
                    <button
                      className="btn btn-sm p-1"
                      onClick={() => {
                        setFilters({
                          minWinPct: "",
                          maxWinPct: "",
                          minOverallPnl: "",
                          maxOverallPnl: "",
                          minAvgPnl: "",
                          maxAvgPnl: "",
                          minLossPct: "",
                          maxLossPct: "",
                          minDays: "",
                          maxDays: "",
                          selectedTags: [],
                          publishedUser: ""
                        });
                      }}
                      style={{ 
                        background: "rgba(255,255,255,0.2)",
                        border: "none",
                        color: "white",
                        fontSize: "14px",
                        padding: "2px 8px"
                      }}
                    >
                      Clear
                    </button>
                  </div>
                  
                  <div className="p-3" style={{ maxHeight: "280px", overflowY: "auto" }}>
                    <div className="d-flex flex-wrap gap-3">
                      {/* Win % */}
                      <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Win % <span style={{ color: "#28a745" }}>✓</span>
                        </label>
                        <div className="d-flex gap-1 align-items-center">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Min"
                            min="0"
                            max="100"
                            step="0.1"
                            value={filters.minWinPct}
                            onChange={(e) => setFilters({ ...filters, minWinPct: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                          <span style={{ color: "#495057", fontSize: "14px" }}>—</span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Max"
                            min="0"
                            max="100"
                            step="0.1"
                            value={filters.maxWinPct}
                            onChange={(e) => setFilters({ ...filters, maxWinPct: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      </div>

                      {/* Loss % */}
                      <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Loss % <span style={{ color: "#dc3545" }}>✗</span>
                        </label>
                        <div className="d-flex gap-1 align-items-center">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Min"
                            min="0"
                            max="100"
                            step="0.1"
                            value={filters.minLossPct}
                            onChange={(e) => setFilters({ ...filters, minLossPct: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                          <span style={{ color: "#495057", fontSize: "14px" }}>—</span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Max"
                            min="0"
                            max="100"
                            step="0.1"
                            value={filters.maxLossPct}
                            onChange={(e) => setFilters({ ...filters, maxLossPct: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      </div>

                      {/* Overall P&L */}
                      <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Overall P&L <span style={{ color: "#28a745" }}>💰</span>
                        </label>
                        <div className="d-flex gap-1 align-items-center">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Min ₹"
                            step="0.01"
                            value={filters.minOverallPnl}
                            onChange={(e) => setFilters({ ...filters, minOverallPnl: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                          <span style={{ color: "#495057", fontSize: "14px" }}>—</span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Max ₹"
                            step="0.01"
                            value={filters.maxOverallPnl}
                            onChange={(e) => setFilters({ ...filters, maxOverallPnl: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      </div>

                      {/* Average P&L */}
                      <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Avg P&L <span style={{ color: "#ffc107" }}>📈</span>
                        </label>
                        <div className="d-flex gap-1 align-items-center">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Min ₹"
                            step="0.01"
                            value={filters.minAvgPnl}
                            onChange={(e) => setFilters({ ...filters, minAvgPnl: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                          <span style={{ color: "#495057", fontSize: "14px" }}>—</span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Max ₹"
                            step="0.01"
                            value={filters.maxAvgPnl}
                            onChange={(e) => setFilters({ ...filters, maxAvgPnl: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      </div>

                      {/* Number of Days */}
                      <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Days <span style={{ color: "#17a2b8" }}>📊</span>
                        </label>
                        <div className="d-flex gap-1 align-items-center">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Min"
                            min="0"
                            step="1"
                            value={filters.minDays}
                            onChange={(e) => setFilters({ ...filters, minDays: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                          <span style={{ color: "#495057", fontSize: "14px" }}>—</span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Max"
                            min="0"
                            step="1"
                            value={filters.maxDays}
                            onChange={(e) => setFilters({ ...filters, maxDays: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      </div>

                      {/* Tags */}
                      <div style={{ minWidth: "200px", flex: "1 1 auto" }}>
                        <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                          Tags <span style={{ color: "#6f42c1" }}>🏷️</span>
                        </label>
                        <Select
                          value={filters.selectedTags.map(tag => ({ value: tag, label: tag }))}
                          onChange={(selected) => setFilters({ ...filters, selectedTags: selected ? selected.map(s => s.value) : [] })}
                          options={getAllTags().map(tag => ({ value: tag, label: tag }))}
                          isMulti
                          placeholder="Select..."
                          styles={{
                            control: (base) => ({
                              ...base,
                              fontSize: "14px",
                              minHeight: "28px",
                              borderColor: "#dee2e6"
                            }),
                            placeholder: (base) => ({
                              ...base,
                              fontSize: "14px"
                            }),
                            multiValue: (base) => ({
                              ...base,
                              fontSize: "14px"
                            })
                          }}
                        />
                      </div>

                      {/* Published By - Only for Subscribed tab */}
                      {activeTab === "marketPlace" && (
                        <div style={{ minWidth: "180px", flex: "1 1 auto" }}>
                          <label className="form-label mb-1 fw-semibold" style={{ fontSize: "14px", color: "#212529" }}>
                            Published By <span style={{ color: "#007bff" }}>👤</span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={filters.publishedUser}
                            onChange={(e) => setFilters({ ...filters, publishedUser: e.target.value })}
                            style={{ fontSize: "14px", padding: "4px 8px" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-start mt-4">
                <div
                  className={`px-2 px-lg-5 py-3 rounded-top ${
                    activeTab === "createdByMe" ? " text-black" : "bg-light"
                  }`}
                  style={{ cursor: "pointer", backgroundColor: "#4dd5b8",whiteSpace:'nowrap',fontSize:'smaller' }}
                  onClick={() => setActiveTab("createdByMe")}
                >
                  Created By Me
                </div>
                <div
                  className={`px-2 px-lg-5 py-3 rounded-top ms-1 ${
                    activeTab === "marketPlace" ? " text-black" : "bg-light"
                  }`}
                  style={{ cursor: "pointer", backgroundColor: "#4dd5b8",whiteSpace:'nowrap',fontSize:'smaller' }}
                  onClick={() => setActiveTab("marketPlace")}
                >
                  Subscribed
                </div>
              </div>

              <span
                className=" fs-6 fw-medium mt-4 ms-1 "
                style={{ color: "black" }}
              >
                {activeTab === "createdByMe" ? "Created By Me" : "Subscribed"}
              </span>

              {loading ? (
                <div style={{ minHeight: "300px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Spinner size="md" text="Loading strategies..." />
                </div>
              ) : viewMode === "grid" ? (
                <Container fluid className="marketplace-items g-0 mt-4" style={{ overflow: "visible" }}>
                  <Row className="marketplace-items-row" style={{ overflow: "visible" }}>
                    {(activeTab === "createdByMe"
                      ? strategiesMe
                      : strategiesSub
                    )?.map((item, index) => (
                      <Col
                        xs={12}
                        lg={6}
                        xl={4}
                        className="marketplace-items-cards  mb-2 mb-md-3"
                        key={index}
                        style={{ position: "relative", zIndex: showActionsDropdown[item.strategy_id] ? 10000 : 1, overflow: "visible" }}
                      >
                        <div
                          className="marketplace-items-cards-card d-flex flex-column justify-content-between h-100"
                          style={{
                            transition: "all 0.3s ease-in-out",
                            border: "2px solid #4dd5b8",
                            borderRadius: "8px",
                            position: "relative",
                            zIndex: showActionsDropdown[item.strategy_id] ? 10000 : 1,
                            overflow: "visible",
                            padding: "12px"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.01)";
                            e.currentTarget.style.borderColor = "#007bff";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(77, 213, 184, 0.3)";
                            e.currentTarget.style.backgroundColor = "#f0fdfa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.borderColor = "#4dd5b8";
                            e.currentTarget.style.boxShadow = "none";
                            e.currentTarget.style.backgroundColor = "";
                          }}
                        >
                          <div>
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <p className="title mb-0 pb-1 fs-6 fw-medium flex-grow-1" style={{ fontSize: "14px" }}>
                            {item?.strategy_name}
                          </p>
                            {item?.is_active && (
                              <span 
                                className="badge"
                                style={{ 
                                  background: "#28a745",
                                  color: "white",
                                  fontSize: "13px",
                                  padding: "2px 6px",
                                  borderRadius: "4px"
                                }}
                              >
                                Active
                              </span>
                            )}
                          </div>
                          <div
                            className="des fs-14 fw-normal" style={{ fontSize: "12px", marginBottom: "8px" }}>
                            <div
                              className="text-truncated"
                              dangerouslySetInnerHTML={{
                                __html: item?.strategy_desc,
                              }}
                            />
                            {hasContent(item?.strategy_desc) && (
                              <span> Read More</span>
                            )}
                          </div>
                          {item.tags && (
                            <div className="card-history mb-2 d-flex align-items-center gap-2 flex-1">
                              {item?.tags.slice(0, 5).map((tags, index) => (
                                <p
                                  className="tags-capsule fs-14 fw-medium" key={index}
                                  style={{
                                    backgroundColor:
                                      TagColors.colors[
                                        index % TagColors.colors.length
                                      ],
                                  }}
                                >
                                  {tags}
                                </p>
                              ))}
                            </div>
                          )}
                          </div>
                          <div>
                          {/* Metrics section with toggle switch */}
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
                              Performance Metrics
                            </span>
                            {(item.has_both_metrics || item.live_metrics) && (
                              <div className="d-flex align-items-center gap-2" onClick={(e) => e.stopPropagation()}>
                                <span style={{ fontSize: "11px", color: "#6c757d", fontWeight: (cyclingMetrics[item.strategy_id] || 'B') === 'B' ? '600' : '400' }}>
                                  Backtest
                                </span>
                                <label className="switch" style={{ margin: 0, cursor: (item.has_both_metrics || item.live_metrics) ? 'pointer' : 'not-allowed' }}>
                                  <input 
                                    type="checkbox" 
                                    checked={(cyclingMetrics[item.strategy_id] || 'B') === 'L'}
                                    onChange={() => handleMetricToggle(item.strategy_id, item)}
                                    disabled={!(item.has_both_metrics || item.live_metrics)}
                                  />
                                  <span className="slider round"></span>
                                </label>
                                <span style={{ fontSize: "11px", color: "#6c757d", fontWeight: (cyclingMetrics[item.strategy_id] || 'B') === 'L' ? '600' : '400' }}>
                                  Live
                                </span>
                              </div>
                            )}
                          </div>
                          <div 
                            className="all-valur-history mb-2 d-grid grid-count-2 gap-2"
                            style={{
                              transition: "opacity 0.5s ease-in-out",
                              opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                            }}
                          >
                            {metrics?.metrics?.map((itm, iddx) => {
                              const currentMetrics = getCurrentMetrics(item);
                              return (
                                <div
                                  className="total-value h-100 mb-1 d-flex align-items-center gap-2 p-1"
                                  key={iddx}
                                  style={{
                                    transition: "all 0.5s ease-in-out"
                                  }}
                                >
                                  <div className="image-area p-1">
                                    <img src={iconMap[itm.icon]} className="img-fluid" alt="" style={{ width: "20px", height: "20px" }} />
                                  </div>
                                  <div className="values">
                                    <p 
                                      className="mb-0 price fs-6 fw-semibold"
                                      style={{
                                        transition: "all 0.5s ease-in-out",
                                        fontSize: "13px"
                                      }}
                                    >
                                      {currentMetrics[itm.key] !== undefined && currentMetrics[itm.key] !== null
                                        ? currentMetrics[itm.key]
                                        : 0}
                                    </p>
                                    <p className="fs-14" style={{ fontSize: "11px", marginBottom: 0 }}>{itm?.title}</p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          </div>
                          
                          {/* Action Buttons */}
                          <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top" onClick={(e) => {
                            // Only stop propagation if not clicking on dropdown
                            if (!e.target.closest('.dropdown')) {
                              e.stopPropagation();
                            }
                          }} style={{ borderTop: "1px solid #e0e0e0", position: "relative", minHeight: "32px" }}>
                            <button 
                              className="btn btn-sm btn-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                setselectedStrategy(item);
                                setSelectedAction("Results");
                                setDetailsModal(true);
                                if (item?.strategy_id) {
                                  getResults();
                                }
                              }}
                              style={{ fontSize: "12px", padding: "4px 12px" }}
                            >
                              View Results
                            </button>
                            
                            {/* Actions Dropdown - Always visible, but items conditionally shown */}
                            <div style={{ position: "relative", zIndex: showActionsDropdown[item.strategy_id] ? 10000 : 1, flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
                              <Dropdown 
                                show={showActionsDropdown[item.strategy_id] || false}
                                onToggle={(isOpen) => {
                                  // Close all other dropdowns, only open the current one if isOpen is true
                                  setShowActionsDropdown({
                                    [item.strategy_id]: isOpen
                                  });
                                }}
                              >
                                <Dropdown.Toggle 
                                  variant="outline-secondary" 
                                  size="sm"
                                  style={{ 
                                    border: "1px solid #dee2e6",
                                    padding: "4px 8px",
                                    fontSize: "13px",
                                    cursor: "pointer"
                                  }}
                                  title="Actions"
                                >
                                  <BsThreeDots style={{ fontSize: "16px" }} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu 
                                  align="end"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ 
                                    zIndex: 10001,
                                    maxHeight: "300px",
                                    overflowY: "auto"
                                  }}
                                  popperConfig={{
                                    strategy: 'absolute',
                                    placement: 'bottom-end',
                                    modifiers: [
                                      {
                                        name: 'offset',
                                        options: {
                                          offset: [0, 4],
                                        },
                                      },
                                      {
                                        name: 'preventOverflow',
                                        options: {
                                          boundary: 'clippingParents',
                                          padding: 8,
                                          altBoundary: false,
                                        },
                                      },
                                      {
                                        name: 'flip',
                                        options: {
                                          fallbackPlacements: ['top-end', 'top-start', 'bottom-end', 'bottom-start'],
                                          boundary: 'clippingParents',
                                        },
                                      },
                                    ],
                                  }}
                                >
                                {(!item.published_user && item.publish_id == 0) && (
                                  <>
                                    <Dropdown.Item 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setselectedStrategy(item);
                                        setSelectedAction("Back Testing");
                                        setActionModal(true);
                                        setActionValues(prev => ({
                                          ...prev,
                                          strategy_id: item.strategy_id,
                                          broker_id: null,
                                          start_date: "",
                                          end_date: "",
                                          interval: "",
                                          run_type: "paper"
                                        }));
                                      }}
                                    >
                                      Back Testing
                                    </Dropdown.Item>
                                    <Dropdown.Item 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowActionsDropdown(prev => ({
                                          ...prev,
                                          [item.strategy_id]: false
                                        }));
                                        setselectedStrategy(item);
                                        setSelectedAction("Live Runs");
                                        setActionModal(true);
                                        setActionValues(prev => ({
                                          ...prev,
                                          strategy_id: item.strategy_id,
                                          broker_id: null,
                                          start_date: "",
                                          end_date: "",
                                          interval: "",
                                          run_type: "paper"
                                        }));
                                      }}
                                    >
                                      Live Runs
                                    </Dropdown.Item>
                                    {/* <Dropdown.Item 
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowActionsDropdown(prev => ({
                                          ...prev,
                                          [item.strategy_id]: false
                                        }));
                                        setselectedStrategy(item);
                                        setSelectedAction("Publish Strategy");
                                        setActionModal(true);
                                        setActionValues(prev => ({
                                          ...prev,
                                          strategy_id: item.strategy_id,
                                          broker_id: null,
                                          start_date: "",
                                          end_date: "",
                                          interval: "",
                                          run_type: "paper"
                                        }));
                                      }}
                                    >
                                      Publish Strategy
                                    </Dropdown.Item> */}
                                    <Dropdown.Divider />
                                    <Dropdown.Item 
                                      className="text-danger"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowActionsDropdown(prev => ({
                                          ...prev,
                                          [item.strategy_id]: false
                                        }));
                                        setselectedStrategy(item);
                                        if (window.confirm("Are you sure you want to delete this strategy?")) {
                                          deleteStrategy();
                                        }
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  </>
                                )}
                                {(item.published_user || item.publish_id != 0) && (
                                  <Dropdown.Item disabled className="text-muted" style={{ fontSize: "12px" }}>
                                    Actions not available for published/subscribed strategies
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Container>
              ) : (
                <div className="mt-4">
                  <style>{`
                    .strategy-table-row:hover {
                      background-color: #f0fdfa !important;
                      transform: scale(1.01);
                      box-shadow: 0 4px 16px rgba(77, 213, 184, 0.25) !important;
                      border-left: 4px solid #4dd5b8 !important;
                      border-top: 2px solid #4dd5b8 !important;
                      border-bottom: 2px solid #4dd5b8 !important;
                      border-right: 2px solid #4dd5b8 !important;
                      border-radius: 6px !important;
                      z-index: 10;
                      margin: 2px 0;
                    }
                  `}</style>
                  <div className="table-responsive">
                    <table className="table align-middle" style={{ fontSize: "14px" }}>
                      <thead style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 10 }}>
                        <tr>
                          <th style={{ minWidth: "200px", fontWeight: "600" }}>Strategy Name</th>
                          <th style={{ minWidth: "80px", fontWeight: "600", textAlign: "center" }}>Status</th>
                          <th style={{ minWidth: "100px", fontWeight: "600", textAlign: "center" }}>Metric Source</th>
                          <th style={{ minWidth: "150px", fontWeight: "600" }}>Description</th>
                          <th style={{ minWidth: "100px", fontWeight: "600", textAlign: "center" }}>Win %</th>
                          <th style={{ minWidth: "100px", fontWeight: "600", textAlign: "center" }}>Loss %</th>
                          <th style={{ minWidth: "120px", fontWeight: "600", textAlign: "center" }}>Overall P&L</th>
                          <th style={{ minWidth: "120px", fontWeight: "600", textAlign: "center" }}>Avg P&L</th>
                          <th style={{ minWidth: "100px", fontWeight: "600", textAlign: "center" }}>Days</th>
                          <th style={{ minWidth: "120px", fontWeight: "600", textAlign: "center" }}>Trade Type</th>
                          <th style={{ minWidth: "150px", fontWeight: "600" }}>Tags</th>
                          {activeTab === "marketPlace" && (
                            <th style={{ minWidth: "150px", fontWeight: "600" }}>Published By</th>
                          )}
                          <th style={{ minWidth: "150px", fontWeight: "600", textAlign: "center" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(activeTab === "createdByMe"
                          ? strategiesMe
                          : strategiesSub
                        )?.map((item, index) => {
                          const tradeTypeMap = { "I": "Intraday", "P": "Positional" };
                          const currentMetrics = getCurrentMetrics(item);
                          const tradeType = currentMetrics?.trade_type ? (tradeTypeMap[currentMetrics.trade_type] || currentMetrics.trade_type) : "-";
                          
                          return (
                            <tr
                              key={index}
                              className="strategy-table-row"
                              style={{ 
                                transition: "all 0.3s ease-in-out",
                                borderLeft: "4px solid transparent",
                                position: "relative"
                              }}
                            >
                              <td>
                                <div className="fw-semibold" style={{ color: "#212529" }}>
                                  {item?.strategy_name}
            </div>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item?.is_active ? (
                                  <span 
                                    className="badge"
                                    style={{ 
                                      background: "#28a745",
                                      color: "white",
                                      fontSize: "14px",
                                      padding: "4px 8px",
                                      borderRadius: "4px"
                                    }}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span style={{ fontSize: "14px", color: "#6c757d", fontWeight: "500" }}>Inactive</span>
                                )}
                              </td>
                              {/* Metric source cell */}
                              <td style={{ textAlign: "center" }}>
                                {getMetricSourceLabel(item) ? (
                                  <span 
                                    className="badge"
                                    style={{ 
                                      background: getMetricSourceColor(item),
                                      color: "white",
                                      fontSize: "13px",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      transition: "all 0.5s ease-in-out",
                                      opacity: metricTransition[item.strategy_id] ? 0.7 : 1,
                                      transform: metricTransition[item.strategy_id] ? "scale(0.95)" : "scale(1)"
                                    }}
                                    title={`Metrics from ${getMetricSourceLabel(item)} ${getMetricSourceLabel(item) === 'Live' ? 'Run' : 'Results'}`}
                                  >
                                    {getMetricSourceLabel(item)}
                                  </span>
                                ) : (
                                  <span style={{ fontSize: "14px", color: "#6c757d" }}>-</span>
                                )}
                              </td>
                              <td>
                                <div
                                  className="text-truncate"
                                  style={{ maxWidth: "200px" }}
                                  dangerouslySetInnerHTML={{
                                    __html: item?.strategy_desc || "-"
                                  }}
                                />
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span 
                                  className="fw-semibold" 
                                  style={{ 
                                    color: "#28a745",
                                    transition: "all 0.5s ease-in-out",
                                    opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                                  }}
                                >
                                  {currentMetrics?.win_pct !== undefined ? `${currentMetrics.win_pct}%` : "-"}
                                </span>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span 
                                  className="fw-semibold" 
                                  style={{ 
                                    color: "#dc3545",
                                    transition: "all 0.5s ease-in-out",
                                    opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                                  }}
                                >
                                  {currentMetrics?.loss_pct !== undefined ? `${currentMetrics.loss_pct}%` : "-"}
                                </span>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span 
                                  className={`fw-semibold ${parseFloat(currentMetrics?.overall_pnl || 0) >= 0 ? "text-success" : "text-danger"}`}
                                  style={{
                                    transition: "all 0.5s ease-in-out",
                                    opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                                  }}
                                >
                                  {currentMetrics?.overall_pnl !== undefined ? `₹${parseFloat(currentMetrics.overall_pnl).toFixed(2)}` : "-"}
                                </span>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span 
                                  className={`fw-semibold ${parseFloat(currentMetrics?.avg_pnl || 0) >= 0 ? "text-success" : "text-danger"}`}
                                  style={{
                                    transition: "all 0.5s ease-in-out",
                                    opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                                  }}
                                >
                                  {currentMetrics?.avg_pnl !== undefined ? `₹${parseFloat(currentMetrics.avg_pnl).toFixed(2)}` : "-"}
                                </span>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span
                                  style={{
                                    transition: "all 0.5s ease-in-out",
                                    opacity: metricTransition[item.strategy_id] ? 0.6 : 1
                                  }}
                                >
                                  {currentMetrics?.no_of_days !== undefined ? currentMetrics.no_of_days : "-"}
                                </span>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <span style={{ color: "#495057", fontSize: "14px" }}>
                                  {tradeType}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex flex-wrap gap-1">
                                  {item.tags && item.tags.length > 0 ? (
                                    item.tags.slice(0, 3).map((tag, tagIndex) => (
                                      <span
                                        key={tagIndex}
                                        className="badge"
                                        style={{
                                          backgroundColor: "#e9ecef",
                                          color: "#495057",
                                          fontSize: "14px",
                                          padding: "2px 6px",
                                          border: "1px solid #dee2e6"
                                        }}
                                      >
                                        {tag}
                                      </span>
                                    ))
                                  ) : (
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>-</span>
                                  )}
                                  {item.tags && item.tags.length > 3 && (
                                    <span style={{ fontSize: "14px", color: "#6c757d" }}>
                                      +{item.tags.length - 3}
                                    </span>
                                  )}
          </div>
                              </td>
                              {activeTab === "marketPlace" && (
                                <td>
                                  <span style={{ color: "#495057" }}>
                                    {item.published_user || "-"}
                                  </span>
                                </td>
                              )}
                              <td style={{ textAlign: "center" }}>
                                <div className="d-flex gap-2 justify-content-center align-items-center" onClick={(e) => e.stopPropagation()}>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setselectedStrategy(item);
                                      setSelectedAction("Results");
                                      setDetailsModal(true);
                                      if (item?.strategy_id) {
                                        getResults();
                                      }
                                    }}
                                    className="btn btn-sm btn-primary"
                                    style={{ fontSize: "13px", padding: "5px 14px" }}
                                  >
                                    View Results
                                  </button>
                                  
                                  {/* Actions Dropdown - Always visible, but items conditionally shown */}
                                  <div style={{ position: "relative", zIndex: showActionsDropdown[item.strategy_id] ? 10000 : 1, flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
                                    <Dropdown 
                                      show={showActionsDropdown[item.strategy_id] || false}
                                      onToggle={(isOpen) => {
                                        // Close all other dropdowns, only open the current one if isOpen is true
                                        setShowActionsDropdown({
                                          [item.strategy_id]: isOpen
                                        });
                                      }}
                                    >
                                      <Dropdown.Toggle 
                                        variant="outline-secondary" 
                                        size="sm"
                                        style={{ 
                                          border: "1px solid #dee2e6",
                                          padding: "4px 8px",
                                          fontSize: "13px",
                                          cursor: "pointer"
                                        }}
                                        title="Actions"
                                      >
                                        <BsThreeDots style={{ fontSize: "16px" }} />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu 
                                        align="end"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ 
                                          zIndex: 10001,
                                          maxHeight: "300px",
                                          overflowY: "auto"
                                        }}
                                        popperConfig={{
                                          strategy: 'absolute',
                                          placement: 'bottom-end',
                                          modifiers: [
                                            {
                                              name: 'offset',
                                              options: {
                                                offset: [0, 4],
                                              },
                                            },
                                            {
                                              name: 'preventOverflow',
                                              options: {
                                                boundary: 'clippingParents',
                                                padding: 8,
                                                altBoundary: false,
                                              },
                                            },
                                            {
                                              name: 'flip',
                                              options: {
                                                fallbackPlacements: ['top-end', 'top-start', 'bottom-end', 'bottom-start'],
                                                boundary: 'clippingParents',
                                              },
                                            },
                                          ],
                                        }}
                                      >
                                      {(!item.published_user && item.publish_id == 0) && (
                                        <>
                                          <Dropdown.Item 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowActionsDropdown(prev => ({
                                                ...prev,
                                                [item.strategy_id]: false
                                              }));
                                              setselectedStrategy(item);
                                              setSelectedAction("Back Testing");
                                              setActionModal(true);
                                              setActionValues(prev => ({
                                                ...prev,
                                                strategy_id: item.strategy_id,
                                                broker_id: null,
                                                start_date: "",
                                                end_date: "",
                                                interval: "",
                                                run_type: "paper"
                                              }));
                                            }}
                                          >
                                            Back Testing
                                          </Dropdown.Item>
                                          <Dropdown.Item 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowActionsDropdown(prev => ({
                                                ...prev,
                                                [item.strategy_id]: false
                                              }));
                                              setselectedStrategy(item);
                                              setSelectedAction("Live Runs");
                                              setActionModal(true);
                                              setActionValues(prev => ({
                                                ...prev,
                                                strategy_id: item.strategy_id,
                                                broker_id: null,
                                                start_date: "",
                                                end_date: "",
                                                interval: "",
                                                run_type: "paper"
                                              }));
                                            }}
                                          >
                                            Live Runs
                                          </Dropdown.Item>
                                          <Dropdown.Item 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowActionsDropdown(prev => ({
                                                ...prev,
                                                [item.strategy_id]: false
                                              }));
                                              setselectedStrategy(item);
                                              setSelectedAction("Publish Strategy");
                                              setActionModal(true);
                                              setActionValues(prev => ({
                                                ...prev,
                                                strategy_id: item.strategy_id,
                                                broker_id: null,
                                                start_date: "",
                                                end_date: "",
                                                interval: "",
                                                run_type: "paper"
                                              }));
                                            }}
                                          >
                                            Publish Strategy
                                          </Dropdown.Item>
                                          <Dropdown.Divider />
                                          <Dropdown.Item 
                                            className="text-danger"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowActionsDropdown(prev => ({
                                                ...prev,
                                                [item.strategy_id]: false
                                              }));
                                              setselectedStrategy(item);
                                              if (window.confirm("Are you sure you want to delete this strategy?")) {
                                                deleteStrategy();
                                              }
                                            }}
                                          >
                                            Delete
                                          </Dropdown.Item>
                                        </>
                                      )}
                                      {(item.published_user || item.publish_id != 0) && (
                                        <Dropdown.Item disabled className="text-muted" style={{ fontSize: "12px" }}>
                                          Actions not available for published/subscribed strategies
                                        </Dropdown.Item>
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {((activeTab === "createdByMe" ? strategiesMe : strategiesSub)?.length === 0) && (
                    <div className="text-center py-5">
                      <p style={{ color: "#495057", fontSize: "16px" }}>No strategies found</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* Results Modal - Simplified */}
          {detailsModal && (
            <>
              {/* Backdrop */}
              <div 
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ 
                  backgroundColor: 'rgba(0,0,0,0.5)', 
                  zIndex: 1040,
                  transition: 'opacity 0.3s ease'
                }} 
                onClick={() => setDetailsModal(false)}
              />
              
              {/* Centered Modal */}
              <div 
                className="position-fixed top-50 start-50 translate-middle bg-white shadow-lg rounded-3"
                onClick={(e) => e.stopPropagation()}
                style={{ 
                  width: '95%',
                  maxWidth: '1400px',
                  maxHeight: '95vh',
                  zIndex: 1050,
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s ease',
                  transform: 'translate(-50%, -50%)'
                }}
              >
                {/* Header */}
                <div 
                  className="d-flex align-items-center justify-content-between p-4"
                  style={{ 
                    borderBottom: '2px solid #e9ecef',
                    background: 'linear-gradient(135deg, #4dd5b8 0%, #3bc4a8 100%)',
                    color: 'white',
                    flexShrink: 0,
                    borderRadius: '0.75rem 0.75rem 0 0'
                  }}
                >
                  <div className="d-flex align-items-center gap-3 flex-grow-1">
                    <h4 className="mb-0 fw-bold d-flex align-items-center gap-2">
                      {selectedStrategy?.strategy_name || "Strategy Results"}
                      {selectedStrategy?.is_active && (
                        <span 
                          className="badge"
                          style={{ 
                            background: "rgba(255,255,255,0.25)",
                            color: "white",
                            fontSize: "13px",
                            padding: "5px 10px",
                            fontWeight: "600"
                          }}
                        >
                          Active
                        </span>
                      )}
                    </h4>
                  </div>
                  
                  <button 
                    type="button" 
                    className="btn btn-link text-white ms-3 p-0"
                    onClick={() => setDetailsModal(false)}
                    aria-label="Close"
                    style={{ fontSize: "28px", lineHeight: "1", textDecoration: "none", fontWeight: "300" }}
                  >
                    ×
                  </button>
                </div>

                  
                {/* Compact Strategy Info - Always Visible */}
                <div className="p-3 border-bottom" style={{ background: "#f8f9fa", flexShrink: 0 }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <span className="fw-semibold" style={{ fontSize: "15px", color: "#495057" }}>
                          {selectedStrategy?.strategy_name || "Strategy"}
                        </span>
                        {selectedStrategy?.is_active && (
                          <span className="badge bg-success" style={{ fontSize: "11px", padding: "3px 8px" }}>
                            Active
                          </span>
                        )}
                      </div>
                      {selectedStrategy?.strategy_desc && (
                        <div 
                          className="text-muted small"
                          style={{ fontSize: "13px", maxHeight: "40px", overflow: "hidden", textOverflow: "ellipsis" }}
                          dangerouslySetInnerHTML={{
                            __html: (selectedStrategy.strategy_desc.replace(/<[^>]*>/g, '').substring(0, 100) + (selectedStrategy.strategy_desc.replace(/<[^>]*>/g, '').length > 100 ? '...' : ''))
                          }}
                        />
                      )}
                    </div>
                    {(!selectedStrategy.published_user && selectedStrategy.publish_id == 0) && (
                      <Link
                        to={`/create-strategies?strategy=${selectedStrategy?.strategy_id}`}
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setDetailsModal(false)}
                        style={{ fontSize: "12px", padding: "4px 12px" }}
                      >
                        <MdEdit className="me-1" style={{ fontSize: "12px" }} />
                        Edit
                      </Link>
                    )}
                  </div>
                </div>

                {/* Modal Body - Reorganized with Results Priority */}
                <div 
                  className="flex-grow-1"
                  style={{ 
                    overflowY: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  {/* Results Section - Always Displayed in Modal */}
                  <div className="p-4" style={{ background: "#fff", flex: "1 1 auto" }}>
                      {/* Metric Source Info Alert */}
                      {selectedStrategy?.run_type && (
                        <div className={`alert d-flex align-items-center gap-2 mb-4`} 
                          style={{ 
                            background: getMetricSourceColor(selectedStrategy) === '#28a745' ? '#d4edda' : '#cce5ff',
                            border: `1px solid ${getMetricSourceColor(selectedStrategy)}`,
                            color: '#155724',
                            fontSize: "14px"
                          }}>
                          <div>
                            <strong>Metric Source:</strong> These metrics are from <strong>{getMetricSourceLabel(selectedStrategy)} {getMetricSourceLabel(selectedStrategy) === 'Live' ? 'Run' : 'Results'}</strong>
                            {getMetricSourceLabel(selectedStrategy) === 'Live' 
                              ? ' - Real-time trading performance data.' 
                              : ' - Historical backtesting simulation results.'}
                          </div>
                        </div>
                      )}
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="fw-bold mb-0" style={{ color: "#495057" }}>Results</h5>
                      </div>
                      <div className="d-flex gap-2 mb-4">
                        <button
                          className={`btn ${resultsActiveTab === "backTesting" ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => {
                            setResultsActiveTab("backTesting");
                            setResultsData([]);
                            setSelectedResult(null);
                          }}
                          style={{ fontSize: "14px", padding: "8px 20px", fontWeight: "600" }}
                        >
                          Back Testing
                        </button>
                        <button
                          className={`btn ${resultsActiveTab === "liveRuns" ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => {
                            setResultsActiveTab("liveRuns");
                            setResultsData([]);
                            setSelectedResult(null);
                          }}
                          style={{ fontSize: "14px", padding: "8px 20px", fontWeight: "600" }}
                        >
                          Live Runs
                  </button>
                </div>

                      {/* Results Content */}
                      {resultsData.length > 0 ? (
                        <div className="row g-4">
                          {/* Runs List - Left Sidebar */}
                          <div className="col-12 col-lg-4">
                            <div className="card" style={{ maxHeight: "70vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                              <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                <h6 className="mb-0 fw-semibold">Run History</h6>
                                <button
                                  className="btn btn-sm btn-light p-1"
                                  onClick={getResults}
                                  title="Refresh results"
                                  style={{ minWidth: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <FaSync />
                                </button>
                              </div>
                              <div className="card-body p-0" style={{ overflowY: "auto", flex: "1" }}>
                                <table className="table table-hover mb-0">
                                  <thead style={{ position: "sticky", top: 0, background: "#f8f9fa", zIndex: 10 }}>
                                    <tr>
                                      <th style={{ fontSize: "13px", padding: "10px" }}>Run Date</th>
                                      <th style={{ fontSize: "13px", padding: "10px" }}>Win %</th>
                                      <th style={{ fontSize: "13px", padding: "10px" }}>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {resultsData.map((item, index) => (
                                      <tr
                                        key={index}
                                        className={selectedResult?.run_id === item.run_id ? "table-primary" : ""}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setSelectedResult(item);
                                          getResultChart(item);
                                        }}
                                      >
                                        <td style={{ padding: "12px 10px", fontSize: "14px" }}>{item.run_ts || "-"}</td>
                                        <td style={{ padding: "12px 10px", fontSize: "14px", fontWeight: "600" }}>{item.metrics?.win_pct || "0"}%</td>
                                        <td style={{ padding: "12px 10px" }}>
                                          <span
                                            className={`badge bg-${item.run_status === "Completed" ? "success" : "danger"}`}
                                            style={{ width: "10px", height: "10px", borderRadius: "50%", display: "inline-block" }}
                                          ></span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* Selected Run Details - Right Side */}
                          {selectedResult && (
                            <div className="col-12 col-lg-8">
                              {/* Run Summary Card */}
                              <div className="card mb-4 shadow-sm border-0">
                                <div className="card-header bg-light">
                                  <h6 className="mb-0 fw-semibold">Run Summary</h6>
                                </div>
                                <div className="card-body">
                                  <div className="row g-3">
                                    <div className="col-6 col-md-3">
                                      <div style={{ fontSize: "13px", color: "#6c757d", fontWeight: "500", marginBottom: "4px" }}>Start Date</div>
                                      <div className="fw-bold" style={{ fontSize: "15px", color: "#495057" }}>{selectedResult.start_date_time ? new Date(selectedResult.start_date_time).toLocaleDateString() : "-"}</div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                      <div style={{ fontSize: "13px", color: "#6c757d", fontWeight: "500", marginBottom: "4px" }}>End Date</div>
                                      <div className="fw-bold" style={{ fontSize: "15px", color: "#495057" }}>{selectedResult.end_date_time ? new Date(selectedResult.end_date_time).toLocaleDateString() : "-"}</div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                      <div style={{ fontSize: "13px", color: "#6c757d", fontWeight: "500", marginBottom: "4px" }}>Overall PnL</div>
                                      <div className={`fw-bold ${parseFloat(selectedResult.metrics?.overall_pnl || 0) >= 0 ? "text-success" : "text-danger"}`} style={{ fontSize: "16px" }}>
                                        ₹{parseFloat(selectedResult.metrics?.overall_pnl || 0).toFixed(2)}
                                      </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                      <div style={{ fontSize: "13px", color: "#6c757d", fontWeight: "500", marginBottom: "4px" }}>Trade Type</div>
                                      <div className="fw-bold" style={{ fontSize: "15px", color: "#495057" }}>{selectedResult.metrics?.trade_type || "-"}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Chart */}
                              {resultChartData?.chart_data && resultChartData.chart_data.length > 0 && (
                                <div className="card mb-4 shadow-sm">
                                  <div className="card-header bg-light">
                                    <h6 className="mb-0 fw-semibold">Performance Chart</h6>
                                  </div>
                                  <div className="card-body p-4">
                                    <LineChart chartdata={resultChartData.chart_data} borderColor={"#4dd5b8"} />
                                  </div>
                                </div>
                              )}

                              {/* Metrics Grid */}
                              <div className="row g-3 mb-4">
                                {metrics?.metrics?.map((itm, iddx) => (
                                  <div className="col-6 col-md-4" key={iddx}>
                                    <div className="card h-100 shadow-sm border-0" style={{ background: "#f8f9fa" }}>
                                      <div className="card-body p-3">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                          <img src={iconMap[itm.icon]} alt="" style={{ width: "24px" }} />
                                          <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "500" }}>{itm.title}</span>
                                        </div>
                                        <div className={`fw-bold fs-5 ${
                                          itm.key === "win_pct" ? "text-success" : 
                                          itm.key === "loss_pct" ? "text-danger" :
                                          (itm.key === "overall_pnl" || itm.key === "avg_pnl") && parseFloat(selectedResult.metrics?.[itm.key] || 0) >= 0 ? "text-success" :
                                          (itm.key === "overall_pnl" || itm.key === "avg_pnl") && parseFloat(selectedResult.metrics?.[itm.key] || 0) < 0 ? "text-danger" : "text-dark"
                                        }`}>
                                          {selectedResult.metrics?.[itm.key] !== undefined 
                                            ? (itm.key === "overall_pnl" || itm.key === "avg_pnl") 
                                              ? `₹${parseFloat(selectedResult.metrics[itm.key]).toFixed(2)}`
                                              : (itm.key === "win_pct" || itm.key === "loss_pct")
                                              ? `${selectedResult.metrics[itm.key]}%`
                                              : selectedResult.metrics[itm.key]
                                            : "0"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {/* Day Details */}
                              {resultChartData?.run_days && resultChartData.run_days.length > 0 && (
                                <div className="card shadow-sm border-0">
                                  <div className="card-header bg-light">
                                    <h6 className="mb-0 fw-semibold">Day Details</h6>
                                  </div>
                                  <div className="card-body p-0">
                                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                      <table className="table table-hover mb-0">
                                        <thead style={{ position: "sticky", top: 0, background: "#f8f9fa", zIndex: 10 }}>
                                          <tr>
                                            <th style={{ fontSize: "13px", padding: "12px" }}>Date</th>
                                            <th style={{ fontSize: "13px", padding: "12px" }}>Day</th>
                                            <th style={{ fontSize: "13px", padding: "12px" }}>PnL</th>
                                            <th style={{ fontSize: "13px", padding: "12px" }}>Details</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {resultChartData.run_days.map((day, index) => (
                                            <tr key={index}>
                                              <td style={{ padding: "12px", fontSize: "14px" }}>{day.run_date || "-"}</td>
                                              <td style={{ padding: "12px", fontSize: "14px" }}>{day.day || "-"}</td>
                                              <td className={parseFloat(day.pnl || 0) >= 0 ? "text-success" : "text-danger"} style={{ padding: "12px", fontSize: "14px", fontWeight: "600" }}>
                                                ₹{parseFloat(day.pnl || 0).toFixed(2)}
                                              </td>
                                              <td style={{ padding: "12px" }}>
                                                <button
                                                  className="btn btn-sm btn-outline-primary"
                                                  onClick={() => toggleAccordion(day, index)}
                                                  style={{ fontSize: "12px", padding: "4px 8px" }}
                                                >
                                                  {openSections === index ? "▼ Hide" : "▶ Show"}
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>

                                    {/* Expanded Details */}
                                    {openSections !== null && dayRunDetails?.ENTRIES && (
                                      <div className="border-top p-4" style={{ background: "#f8f9fa" }}>
                                        <h6 className="fw-semibold mb-3">Trade Details</h6>
                                        <div className="table-responsive">
                                          <table className="table table-sm table-bordered">
                                            <thead style={{ background: "#e9ecef" }}>
                                              <tr>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Symbol Type</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Symbol</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Order Type</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Quantity</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Price</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>Timestamp</th>
                                                <th style={{ fontSize: "12px", padding: "10px" }}>PNL</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {isLoadingDetails ? (
                                                <tr>
                                                  <td colSpan="7" className="text-center p-4">
                                                    <Spinner size="sm" text="Loading..." />
                                                  </td>
                                                </tr>
                                              ) : (
                                                dayRunDetails.ENTRIES.map((entry, idx) => (
                                                  <tr key={idx}>
                                                    {Object.entries(entry).map(([key, value], i) => (
                                                      <td key={i} style={{ fontSize: "13px", padding: "10px" }}>{value || "-"}</td>
                                                    ))}
                                                  </tr>
                                                ))
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {resultsData.length > 0 && !selectedResult && (
                            <div className="col-12">
                              <div className="card shadow-sm">
                                <div className="card-body text-center p-5">
                                  <p className="mb-0 text-muted" style={{ fontSize: "16px" }}>
                                    Select a run from the list to view detailed results
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="col-12">
                          <div className="card shadow-sm">
                            <div className="card-body text-center p-5">
                              <p className="mb-0 text-muted" style={{ fontSize: "16px" }}>
                                {resultsActiveTab === "backTesting" ? "No back testing results available" : "No live run results available"}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                </div>

                {/* Footer */}
                <div 
                  className="d-flex align-items-center justify-content-end p-3 border-top"
                  style={{ 
                    borderTop: '1px solid #e9ecef',
                    background: "#f8f9fa",
                    flexShrink: 0,
                    borderRadius: '0 0 0.75rem 0.75rem'
                  }}
                >
                  <button
                    className="btn btn-secondary"
                    onClick={() => setDetailsModal(false)}
                    style={{ fontSize: "14px", padding: "6px 20px" }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </>
          )}

          {/* Action Form Modal - Separate Modal for Actions */}
          {actionModal && selectedAction && selectedAction !== "Results" && (
            <>
              {/* Backdrop */}
              <div 
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ 
                  backgroundColor: 'rgba(0,0,0,0.5)', 
                  zIndex: 1060,
                  transition: 'opacity 0.3s ease'
                }} 
                onClick={() => {
                  setActionModal(false);
                  setSelectedAction(null);
                }}
              />
              
              {/* Centered Action Form Modal */}
              <div 
                className="position-fixed top-50 start-50 translate-middle bg-white shadow-lg rounded-3"
                onClick={(e) => e.stopPropagation()}
                style={{ 
                  width: '90%',
                  maxWidth: '600px',
                  maxHeight: '90vh',
                  zIndex: 1070,
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s ease',
                  transform: 'translate(-50%, -50%)'
                }}
              >
                {/* Header */}
                <div 
                  className="d-flex align-items-center justify-content-between p-4"
                  style={{ 
                    borderBottom: '2px solid #e9ecef',
                    background: 'linear-gradient(135deg, #4dd5b8 0%, #3bc4a8 100%)',
                    color: 'white',
                    flexShrink: 0,
                    borderRadius: '0.75rem 0.75rem 0 0'
                  }}
                >
                  <h5 className="mb-0 fw-bold">{selectedAction}</h5>
                  <button 
                    type="button" 
                    className="btn btn-link text-white ms-3 p-0"
                    onClick={() => {
                      setActionModal(false);
                      setSelectedAction(null);
                    }}
                    aria-label="Close"
                    style={{ fontSize: "24px", lineHeight: "1", textDecoration: "none", fontWeight: "300" }}
                  >
                    ×
                  </button>
                </div>

                {/* Form Body */}
                <div 
                  className="p-4 flex-grow-1"
                  style={{ 
                    overflowY: 'auto',
                    flexGrow: 1
                  }}
                >
                  {selectedAction !== "Publish Strategy" && (
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Select Broker</label>
                      <Select
                        options={brokers}
                        value={brokers.find(opt => opt.broker_id === actionValues.broker_id) || null}
                        onChange={(selected) => handleActionSelectChange("broker_id", selected ? selected.broker_id : null)}
                        placeholder="Select Broker"
                      />
                    </div>
                  )}

                  {selectedAction === "Live Runs" && (
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Run Type</label>
                      <div className="d-flex gap-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="run_type"
                            id="paper_test_action"
                            value="paper"
                            checked={actionValues.run_type === "paper"}
                            onChange={(e) => handleActionSelectChange("run_type", e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="paper_test_action">Paper Test</label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="run_type"
                            id="live_orders_action"
                            value="live"
                            checked={actionValues.run_type === "live"}
                            onChange={(e) => handleActionSelectChange("run_type", e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="live_orders_action">Live Orders</label>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <FormBox
                        type="date"
                        label="From"
                        placeholder="mm/dd/yyyy"
                        min={selectedAction === "Back Testing" ? calculateDate(-90) : calculateDate(0)}
                        max={null}
                        value={actionValues.start_date}
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          if (selectedAction === "Back Testing" && selectedDate > today) {
                            toast.error("Start date cannot be in the future for Back Testing");
                            return;
                          }
                          handleActionSelectChange("start_date", e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormBox
                        type="date"
                        label="To"
                        placeholder="mm/dd/yyyy"
                        min={selectedAction === "Back Testing" ? calculateDate(-90) : calculateDate(0)}
                        max={null}
                        value={actionValues.end_date}
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          if (selectedAction === "Back Testing" && selectedDate > today) {
                            toast.error("End date cannot be in the future for Back Testing");
                            return;
                          }
                          handleActionSelectChange("end_date", e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  {selectedAction !== "Publish Strategy" && (
                    <div className="mb-4">
                      <label className="form-label fw-semibold">Select Interval</label>
                      <Select
                        options={intervalOptions}
                        value={intervalOptions.find(opt => opt.value === actionValues.interval) || null}
                        onChange={(selected) => handleActionSelectChange("interval", selected ? selected.value : "")}
                        placeholder="Select Interval"
                      />
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div 
                  className="d-flex align-items-center justify-content-end gap-2 p-4 border-top"
                  style={{ 
                    borderTop: '1px solid #e9ecef',
                    background: "#f8f9fa",
                    flexShrink: 0,
                    borderRadius: '0 0 0.75rem 0.75rem'
                  }}
                >
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setActionModal(false);
                      setSelectedAction(null);
                    }}
                    style={{ fontSize: "14px", padding: "8px 20px" }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={executeAction}
                    style={{ fontSize: "14px", padding: "8px 20px" }}
                  >
                    {selectedAction}
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}
